// Theme toggle. data-theme on <html>, persisted in localStorage.
// Defaults to light on first visit; user can opt into dark via toggle.

const KEY = 'shotmeal:theme';
export type Theme = 'light' | 'dark';

export function initTheme() {
  const stored = (localStorage.getItem(KEY) as Theme | null) ?? null;
  applyTheme(stored ?? 'light');
}

export function getTheme(): Theme {
  return (document.documentElement.getAttribute('data-theme') as Theme) || 'light';
}

export function setTheme(t: Theme) {
  applyTheme(t);
  localStorage.setItem(KEY, t);
}

export function toggleTheme() {
  setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

function applyTheme(t: Theme) {
  document.documentElement.setAttribute('data-theme', t);
  document.querySelector('meta[name="theme-color"]')?.setAttribute(
    'content',
    t === 'dark' ? '#14131A' : '#FFE9CE',
  );
}
